import { render } from "./Preenchimento.vue?vue&type=template&id=3a9a80ba"
import script from "./Preenchimento.vue?vue&type=script&lang=js"
export * from "./Preenchimento.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__